import { ButtonERP, Checkbox, SearchInput } from "@finanedi.es/storybook"
import { uniqueId } from "lodash"
import { Dispatch, SetStateAction, useState } from "react"
import { useTranslation } from "react-i18next"
import { List, ListItem } from "./useFilteredList"

interface FilteredListProps<T> {
  inputId: string
  filteredList: List<T> | undefined
  itemsSelected: List<T> | undefined
  searchItem: string | undefined
  label: keyof T
  setItemsSelected: Dispatch<SetStateAction<List<T> | undefined>>
  onSearchItem: (value: string) => void
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function FilteredList<T extends { id?: $TSMigrationFixMe }>({
  inputId,
  filteredList,
  itemsSelected,
  searchItem,
  label,
  setItemsSelected,
  onSearchItem,
}: FilteredListProps<T>) {
  const { t } = useTranslation()
  const handleOnClick = (item: ListItem<T>) => {
    const newItemSelected = itemsSelected?.includes(item)
      ? itemsSelected?.filter(
          (selectedItem: ListItem<T>) => selectedItem !== item
        )
      : [...(itemsSelected || []), item]
    setItemsSelected(newItemSelected)
  }
  const DEFAULT_LIST_LENGTH = 4
  const [listLength, setListLength] = useState<number | undefined>(
    DEFAULT_LIST_LENGTH
  )

  return (
    <div id={inputId}>
      <SearchInput
        placeholder={`${t("filtros.contactos.placeholderSearch")}`}
        onChange={(ev: string) => {
          onSearchItem(ev)
        }}
        inputValue={searchItem}
        className='tw-mb-2 tw-w-full'
      />
      {filteredList?.slice(0, listLength)?.map((item: ListItem<T>) => (
        <div
          key={`${uniqueId()}`}
          className='tw-mb-2 tw-flex hover:!tw-bg-gray-100 tw-p-1 tw-rounded-md tw-cursor-pointer tw-transition-colors tw-duration-300 tw-ease-in-out tw-items-center'
          onClick={() => handleOnClick(item)}
        >
          <Checkbox
            id={item && typeof item === "object" ? item?.id : String(item)}
            isChecked={Boolean(itemsSelected?.includes(item))}
          />
          <p className='tw-my-auto tw-ml-2 tw-truncate !tw-lowercase first-line:!tw-capitalize tw-text-sm'>
            {item[label] as string}
          </p>
        </div>
      ))}
      {filteredList && filteredList?.length > DEFAULT_LIST_LENGTH && (
        <ButtonERP
          customize={{ size: "sm", type: "transparent" }}
          onClick={() =>
            setListLength(listLength ? undefined : DEFAULT_LIST_LENGTH)
          }
          className='tw-w-full'
          label={
            listLength
              ? `${t("empresasGestionadas.filterMenu.seeMore")}`
              : `${t("empresasGestionadas.filterMenu.seeLess")}`
          }
        />
      )}
    </div>
  )
}
